import { render, staticRenderFns } from "./model-nav-button.vue?vue&type=template&id=0fbd64d8&scoped=true&lang=html"
import script from "./model-nav-button.vue?vue&type=script&lang=js"
export * from "./model-nav-button.vue?vue&type=script&lang=js"
import style0 from "./model-nav-button.vue?vue&type=style&index=0&id=0fbd64d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbd64d8",
  null
  
)

export default component.exports